// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"50d96b69","263":"2a50a8a6","301":"85613032","374":"9adcf3de","383":"d87f3927","493":"2900383b","509":"dbdea71f","538":"c2596f07","613":"a9cccd36","769":"4e7c7f03","776":"87a59491","819":"acbda509","854":"47c36a9a","934":"2a89b888"}[chunkId] + ".chunk.js";
};